import React from 'react';

interface VerticalSpacerProps {
    readonly heightValue: number;
}
export const VerticalSpacer: React.FC<VerticalSpacerProps> = ({ heightValue }) => (
    <div className={`mt-${heightValue}`}></div>
);
